import "./loader.css"

export const Loader= () => {
  return (
      <div className="loading-spinner" />
  );
}